export default {
  'driver-out': 'Estafeta a caminho',
  'data-unavailable': 'Dados indisponíveis',
  delivered: 'Entregue',
  'wrong-address': 'Morada errada',
  'not-present': 'Ausente',
  'order-canceled': 'Encomenda cancelada',
  'delivery-attempted': 'Tentativa de entrega',
  rescheduled: 'Reagendada',
  'date-unavailable': 'Data indisponível',
}
